import { getDispatch } from '../get-dispatch';
import { DispatchAction } from '../utility/dispatch-action';
import { AlertActions, ALERT_STATE_NAMESPACE } from './alert.module-types';

export const dispatchAlertAction: DispatchAction<AlertActions> = getDispatch(
  ALERT_STATE_NAMESPACE
);
